// extracted by mini-css-extract-plugin
module.exports = {"container":"SignUp_container__2Dblk","header":"SignUp_header__3tdbh","form":"SignUp_form__3-wsa","logo":"SignUp_logo__A8QT2","error":"SignUp_error__3ptjC"};